<div class="row_item">
  <div class="imageSide">
    <img class="imageSide__img" [src]="imageUrl()" />
    <div class="imageSide__Uploadbutton">
      <app-category-upload-image (image)="onSelectedImage($event)">
      </app-category-upload-image>
    </div>
    <svg class="imageSide__Maxbutton" (click)="Maximize()">
      <use xlink:href="images/sprites5.svg#icon-eye"></use>
    </svg>
  </div>

  <div class="row_item__name">
    <div class="input_title">Category:</div>
    <div class="drop_down_mid">
      <app-dropdown-admin
        [input_dropdown_title]="categoryTitle()"
        [input_dropdown_options]="categories"
        (selectedId)="onCategorySelect($event)"
        (keydown)="onInputChange($event, Id())"
      />
    </div>

    <div class="product_name">
      <div class="input_title">Product Name:</div>
      <div>
        <app-dropdown-mini-admin
          [input_dropdown_title]="'TR'"
          [input_dropdown_options]="['TR', 'EN', 'AR']"
          (select)="onNameLanguageSelect($event)"
        />
      </div>
    </div>
    @if(selectedLanguageName === 'TR'){
    <input
      type="text"
      class="name_input item_input--mid"
      placeholder="product name"
      (keydown)="onInputChange($event, Id())"
      [(ngModel)]="newNameTr"
    />
    } @else if (selectedLanguageName === 'EN'){
    <input
      type="text"
      class="name_input item_input--mid"
      placeholder="product name"
      (keydown)="onInputChange($event, Id())"
      [(ngModel)]="newNameEn"
    />
    } @else if(selectedLanguageName === 'AR'){
    <input
      type="text"
      class="name_input item_input--mid"
      placeholder="product name"
      (keydown)="onInputChange($event, Id())"
      [(ngModel)]="newNameAr"
    />
    }
  </div>

  <div class="row_item__prices">
    <div class="input_title">Prices:</div>
    <div class="price_language">
      <input
        type="text"
        class="item_input item_input--small"
        placeholder="TR"
        (keydown)="onInputChange($event, Id())"
        [(ngModel)]="newPriceTr"
      />
    </div>

    <div class="price_language">
      <input
        type="text"
        class="item_input item_input--small"
        placeholder="EN"
        (keydown)="onInputChange($event, Id())"
        [(ngModel)]="newPriceEn"
      />
    </div>

    <div class="price_language">
      <input
        type="text"
        class="item_input item_input--small"
        placeholder="AR"
        (keydown)="onInputChange($event, Id())"
        [(ngModel)]="newPriceAr"
      />
    </div>

  </div>

  <div class="row_item__description">
    <div class="description">
      <div class="input_title">Description:</div>
      <app-dropdown-mini-admin
        [input_dropdown_title]="'TR'"
        [input_dropdown_options]="['TR', 'EN', 'AR']"
        (select)="onDescriptionLanguageSelect($event)"
      />
    </div>
    @if(selectedLanguageDescription === 'TR'){
    <div class="input_description">
      <textarea
        class="custom-textarea"
        rows="4"
        cols="50"
        wrap="hard"
        placeholder="Item description"
        (keydown)="onInputChange($event, Id())"
        [(ngModel)]="newDescriptionTr"
      ></textarea>
    </div>
    } @else if(selectedLanguageDescription === 'EN'){
    <div class="input_description">
      <textarea
        class="custom-textarea"
        rows="4"
        cols="50"
        wrap="hard"
        placeholder="Item description"
        (keydown)="onInputChange($event, Id())"
        [(ngModel)]="newDescriptionEn"
      ></textarea>
    </div>
    } @else if(selectedLanguageDescription === 'AR'){
    <div class="input_description">
      <textarea
        class="custom-textarea"
        rows="4"
        cols="50"
        wrap="hard"
        placeholder="Item description"
        (keydown)="onInputChange($event, Id())"
        [(ngModel)]="newDescriptionAr"
      ></textarea>
    </div>
    }
  </div>

  <div class="row_item__sidecontroll">
    <div (click)="onDelete(Id())">
      <svg class="icon icon__delete">
        <use xlink:href="images/sprites5.svg#icon-bin2"></use>
      </svg>
    </div>

    @if(newisVisible()){
    <div (click)="onIconClick(Id())">
      <svg class="icon icon__hide">
        <use xlink:href="images/sprites5.svg#icon-eye"></use>
      </svg>
    </div>

    } @else{
    <div (click)="onIconClick(Id())">
      <svg class="icon icon__hide">
        <use xlink:href="images/sprites5.svg#icon-eye-blocked"></use>
      </svg>
    </div>

    }
    <div>
      <svg
        class="icon icon__list"
        [routerLink]="['/admin/orderItems/', newcategoryId()]"
      >
        <use xlink:href="images/sprites5.svg#icon-list-ul"></use>
      </svg>
    </div>
  </div>
</div>
